'use strict';

import { Parser } from 'json2csv';
import FileSaver from 'file-saver';
import Blob from 'blob'; // universal blob support for browsers
import moment from 'moment';

/**
 * Save files directly from client
 */
function FileSaveSvc() {
  /**
   * Save data as CSV directly from client
   * @param  {Object} csvObject           object for json2csv (data, fields)
   * @param  {String} [filename='export']
   * @param  {boolean} includeDate        include date in filename
   */
  this.saveAsCsv = function(csvObject, filename = 'export', includeDate) {
    // get csv string/content using Parser API
    const parser = new Parser({ fields: csvObject.fields });
    var csvContent = parser.parse(csvObject.data);
    // convert to exportable blob (UTF-8, browser safe)
    var blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    if(includeDate) {
      filename += '_' + moment().format('YYYY-MM-DD') + '.csv';
    }
    FileSaver.saveAs(blob, filename);
  };

  return this;
}

export default [FileSaveSvc];
